<template>
  <div class="view" v-if="canView && selectedReport && selectedReport.id" v-cloak>
      <ReportGridView :templateData="selectedReport" :showModule="true" @hideReportGridView="hideReportGridView"></ReportGridView>
  </div>
  <div v-else>
    <forbidden></forbidden>
  </div>
</template>

<script>
import Forbidden from "@/pages/errors/Forbidden.vue";
import { canView, permissions, permissionTypes } from "@/helpers/Permissions";
import ReportGridView from "../partials/reportGridView.vue";

export default {
  name: "ReportView",
  components: {
    Forbidden,
    ReportGridView,
  },
  props: {
    report: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      selectedReport: this.report || {},
    };
  },
  watch: {
    report(newVal) {
      this.selectedReport = newVal || {};
    },
  },
  computed: {
    config() {
      return {
        permission: permissions.REPORTS,
        permission_type: permissionTypes.module,
      };
    },
    canView() {
      return canView(this);
    },
  },
  methods: {
    hideReportGridView() {
      if (this.$router) {
        if (window.history.length > 1) {
          this.$router.go(-1);
        } else {
          this.$router.back();
        }
      }
    },
  },
};
</script>
